// extracted by mini-css-extract-plugin
export default {"wrap":"Gr-z","fullWidth":"Hr-z","items":"Ir-z","featureCss":"Jr-z","disabled":"Kr-z","imgCss":"Lr-z"};